import { render, staticRenderFns } from "./LookFile.vue?vue&type=template&id=18c37480&scoped=true&"
import script from "./LookFile.vue?vue&type=script&lang=js&"
export * from "./LookFile.vue?vue&type=script&lang=js&"
import style0 from "./LookFile.vue?vue&type=style&index=0&id=18c37480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c37480",
  null
  
)

export default component.exports